/**
 * FormatFilterBody Component
 *
 * Renders product format chips inside the FiltersModal body for the Format
 * tab. Multi-select: an empty selection means every format, which is the
 * page's default.
 */

// React
import { useMemo } from 'react';

// Hooks and utilities
import { cn } from '@/lib/utils';
import { TEXT_CHIP_BASE, CHIP_UNSELECTED, CHIP_SELECTED } from './filterChipStyles';

// Types
import { PRODUCT_FORM_VALUES, DEFAULT_FORM_LABELS } from '../types';
import type { ProductForm } from '../types';

/* ---- Layout constants ---- */
const WRAP_CLASSES = 'flex flex-wrap gap-3';

/* ---- Types ---- */
interface FormatFilterBodyProps {
  selectedFormats: ProductForm[];
  onToggle: (format: ProductForm) => void;
}

/* ---- Component ---- */
export function FormatFilterBody({ selectedFormats, onToggle }: FormatFilterBodyProps) {
  const selectedSet = useMemo(() => new Set(selectedFormats), [selectedFormats]);

  return (
    <div className={WRAP_CLASSES}>
      {PRODUCT_FORM_VALUES.map((format) => {
        const isSelected = selectedSet.has(format);
        return (
          <button
            key={format}
            type="button"
            role="checkbox"
            aria-checked={isSelected}
            className={cn(TEXT_CHIP_BASE, isSelected ? CHIP_SELECTED : CHIP_UNSELECTED)}
            onClick={() => onToggle(format)}
          >
            {DEFAULT_FORM_LABELS[format]}
          </button>
        );
      })}
    </div>
  );
}
